module.exports = __webpack_public_path__ + "static/images/logo-getty.1e8ac7010523f761ddc1099e56e10c3c.png";